import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { injectCss } from "@insite/mobius/utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: 245px;
        max-height: none;
        min-width: 245px;
        padding: 16px;
    `,
};

